// Helper de calcul de plage de dates pour les filtres JDMA partagés.
// periodFilter = { preset: 'week'|'month'|'7d'|'30d'|'90d'|'365d'|'custom', from?, to? }

export const PERIOD_PRESETS = [
  { value: 'week',   label: 'Semaine en cours' },
  { value: 'month',  label: 'Mois en cours' },
  { value: '7d',     label: '7 derniers jours' },
  { value: '30d',    label: '30 derniers jours' },
  { value: '90d',    label: '90 derniers jours' },
  { value: '365d',   label: '1 an' },
  { value: 'custom', label: 'Période personnalisée' },
];

function startOfWeekMonday(d) {
  const date = new Date(d);
  const day = date.getDay(); // 0=Dim, 1=Lun, ..., 6=Sam
  const diff = day === 0 ? -6 : 1 - day;
  date.setDate(date.getDate() + diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

function endOfWeekSunday(d) {
  const start = startOfWeekMonday(d);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  end.setHours(23, 59, 59, 999);
  return end;
}

function startOfMonth(d) {
  const date = new Date(d);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

function endOfMonth(d) {
  const date = new Date(d);
  date.setMonth(date.getMonth() + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

function daysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d;
}

function endOfToday() {
  const d = new Date();
  d.setHours(23, 59, 59, 999);
  return d;
}

export function computeDateRange(periodFilter) {
  const pf = periodFilter || {};
  switch (pf.preset) {
    case 'week':
      return {
        from: startOfWeekMonday(new Date()).toISOString(),
        to:   endOfWeekSunday(new Date()).toISOString(),
      };
    case 'month':
      return {
        from: startOfMonth(new Date()).toISOString(),
        to:   endOfMonth(new Date()).toISOString(),
      };
    case '7d':   return { from: daysAgo(7).toISOString(),   to: endOfToday().toISOString() };
    case '90d':  return { from: daysAgo(90).toISOString(),  to: endOfToday().toISOString() };
    case '365d': return { from: daysAgo(365).toISOString(), to: endOfToday().toISOString() };
    case 'custom': {
      const from = pf.from ? new Date(pf.from + 'T00:00:00').toISOString() : daysAgo(30).toISOString();
      const to   = pf.to   ? new Date(pf.to   + 'T23:59:59').toISOString() : endOfToday().toISOString();
      return { from, to };
    }
    case '30d':
    default:
      return { from: daysAgo(30).toISOString(), to: endOfToday().toISOString() };
  }
}

export function loadPeriodFilter() {
  try {
    const raw = sessionStorage.getItem('jdma_period_filter');
    if (!raw) return { preset: '30d', from: null, to: null };
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && parsed.preset) return parsed;
  } catch (_) { /* ignore */ }
  return { preset: '30d', from: null, to: null };
}

export function savePeriodFilter(periodFilter) {
  try {
    sessionStorage.setItem('jdma_period_filter', JSON.stringify(periodFilter));
  } catch (_) { /* ignore */ }
}
